export class EntEntityTypesFilter {
    page: number = 1;
    size: number = 30;
    codeOrName: string | null = null;
    createdFrom: string | null = null;
    createdTo: string | null = null;
    deleted: boolean = false;
}
